import { Injectable, Inject } from '@angular/core';

/**
 * User service.
 *
 * The public interface for the element store.
 */
@Injectable({
  providedIn: 'root'
})
export class UserServiceDepricated {

  /** Legacy Auth reference. */
  private sgAuthService: any;

  /** Constructor. */
  constructor(
    @Inject('sgAuth') sgAuthService: any
  ) {
    this.sgAuthService = sgAuthService;
  }

  /**
   * Get the current active user.
   *
   * @returns Current active user.
   */
  public getActive(): User {
    return this.sgAuthService.getCurrentUser();
  }

}
